<ngx-sonner-toaster [richColors]="true" />
<router-outlet />
